.main-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  height: 100%;
}

.inventory-section {
  flex-wrap: nowrap;
  position: relative;
  justify-content: space-around;
  flex: 1;
}

.inventory-loader {
  &:first-of-type {
    flex: 3;
  }
  &:nth-of-type(2) {
    flex: 2;
  }
  &:last-of-type {
    flex: 1;
  }
}

.container {
  flex-wrap: nowrap;
}

.has-separator {
  border-left: 1px solid var(--chart-101-pressed-dividers);
}

gz-inventory-item {
  display: inline-flex;
  width: fit-content;
  justify-content: center;
  flex: 1;
  cursor: default;
}

gz-loader {
  height: auto;
  padding: 0 calc(var(--spacer) * 4);
}

.changed-info-box {
  position: absolute;
  background-color: var(--white-layout-302-level-1-elevation);
  z-index: 1;
  top: calc(var(--spacer) * -2);
  height: calc(100% + var(--spacer) * 4);
  overflow: auto;

  gz-info-box {
    padding: calc(var(--spacer) * 1.25) 0 0 0;
    --info-box-min-height: 0;
    --info-box-width: 100%;
    --info-box-icon-padding: 0 calc(var(--spacer) * 2);
    --info-box-message-padding: 0 calc(var(--spacer) * 1.25) 0 0;
    --info-box-message-width: calc(100% - var(--spacer) * 7);

    gz-tooltip {
      width: 100%;
    }
  }
}
